import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { handleGetPricingPlans, handleUpdatePricingPlans } from "../../axios";
import { toast } from "react-toastify";

const PricingPlans = () => {
  const navigate = useNavigate();
  const [plansData, setPlansData] = useState(null);
  const [loading, setLoading] = useState(false);

  const { data: pricingPlansData } = useQuery(["plans"], () =>
    handleGetPricingPlans()
  );

  useEffect(() => {
    if (pricingPlansData) {
      setPlansData(pricingPlansData.data);
    }
  }, [pricingPlansData]);

  const handleInputChange = (e, planIndex, typeIndex, field) => {
    const updatedPlansData = [...plansData];
    updatedPlansData[planIndex].types[typeIndex][field] = e.target.value;
    setPlansData(updatedPlansData);
  };

  const handleLogUpdatedData = async () => {
    setLoading(true);
    try {
      const res = await handleUpdatePricingPlans(plansData);

      if (res.status === 200) {
        toast.success(res.data.message, {
          position: "top-right",
        });
      } else {
        toast.error(res.data.message, {
          position: "top-right",
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="flex  items-center justify-between">
        <p className="font-semibold antialiased tracking-wide text-[22px]">
          Pricing Plans
        </p>

        <button
          onClick={handleLogUpdatedData}
          className="bg-[#4186F6] h-10 w-[240px] text-white rounded-[8px]"
        >
          {loading ? <p>Updating...</p> : <p>Update Pricing Plans</p>}
        </button>
      </div>

      <div className="">
        {pricingPlansData?.data?.map((plan, planIndex) => (
          <div key={planIndex} className="grid grid-cols-2 mt-10 gap-20">
            {plan?.types?.map((type, typeIndex) => (
              <div className="ring-2 ring-gray-200 p-4">
                <p className="text-[18px] font-semibold text-slate-700 tracking-normal antialiased">
                  {type.name}
                </p>

                <div className="mt-5">
                  <div>
                    <p className="text-slate-500">Name</p>
                    <input
                      className="outline-none ring-2 ring-gray-200 h-12 w-full mt-3 rounded-[8px] indent-3"
                      placeholder="Ex:SEO Insights Free Plan"
                      value={type.name}
                      onChange={(e) =>
                        handleInputChange(e, planIndex, typeIndex, "name")
                      }
                    />
                  </div>
                  <div className="mt-3">
                    <p className="text-slate-500">Type</p>
                    <input
                      className="outline-none ring-2 ring-gray-200 h-12 w-full mt-3 rounded-[8px] indent-3"
                      placeholder="Ex:free"
                      value={type.status}
                      onChange={(e) =>
                        handleInputChange(e, planIndex, typeIndex, "status")
                      }
                    />
                  </div>
                  <div className="mt-3">
                    <p className="text-slate-500">Description</p>
                    <input
                      className="outline-none ring-2 ring-gray-200 h-12 w-full mt-3 rounded-[8px] indent-3"
                      placeholder="Ex:Experience the power of SEO Insights with our Pro Plan"
                      value={type.description}
                      onChange={(e) =>
                        handleInputChange(
                          e,
                          planIndex,
                          typeIndex,
                          "description"
                        )
                      }
                    />
                  </div>
                  <div className="mt-3">
                    <p className="text-slate-500">Price</p>
                    <input
                      className="outline-none ring-2 ring-gray-200 h-12 w-full mt-3 rounded-[8px] indent-3"
                      placeholder="Ex: 20.0"
                      value={type.price}
                      onChange={(e) =>
                        handleInputChange(e, planIndex, typeIndex, "price")
                      }
                    />
                  </div>
                  <div className="mt-3">
                    <p className="text-slate-500">Period</p>
                    <input
                      className="outline-none ring-2 ring-gray-200 h-12 w-full mt-3 rounded-[8px] indent-3"
                      placeholder="Ex: Month"
                      value={type.type}
                      onChange={(e) =>
                        handleInputChange(e, planIndex, typeIndex, "type")
                      }
                    />
                  </div>
                  <div className="mt-3">
                    <p className="text-slate-500">Benefits</p>
                    <textarea
                      className="outline-none ring-2 ring-gray-200 h-12 w-full mt-3 rounded-[8px] p-3"
                      placeholder="Ex: Unlimited domains"
                      style={{ resize: "vertical", height: "200px" }}
                      value={type.benefits}
                      onChange={(e) =>
                        handleInputChange(e, planIndex, typeIndex, "benefits")
                      }
                    />
                    <p className="text-slate-400">
                      use , seperated values for multiple benefits
                    </p>
                  </div>
                  <div className="mt-3">
                    <p className="text-slate-500">Non-Benefits</p>
                    <textarea
                      className="outline-none ring-2 ring-gray-200 h-12 w-full mt-3 rounded-[8px] p-3"
                      placeholder="Ex: Download Reports"
                      style={{ resize: "vertical", height: "200px" }}
                      value={type.nonBenefits}
                      onChange={(e) =>
                        handleInputChange(
                          e,
                          planIndex,
                          typeIndex,
                          "nonBenefits"
                        )
                      }
                    />
                    <p className="text-slate-400">
                      use , seperated values for multiple non-benefits
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingPlans;
